import { FirmManagementUserControls } from './components/firm-management-user-controls.tsx'
import { useRef, useState } from 'react'
import { useListFirmsQuery } from '../../apis/firm-management/firm-management-api.api.ts'
import { FirmStatus } from '../../enums/management-input.enum.ts'
import { FirmManagementTable } from './components/firm-management-table.tsx'
import { ActionFirmModal } from './components/firm-modal/action-firm-modal.tsx'
import { FirmManagementFormFieldTypes } from './components/firm-modal/firm-management-form.tsx'
import Form from 'antd/es/form/index'
import { ActionGroupModal } from './components/group-modal/action-group-modal.tsx'
import { GroupManagementFormFieldTypes } from './components/group-modal/group-management-form.tsx'
import { useTableHeight } from '../../common/hooks/use-table-height.ts'

export const FirmManagement = () => {
  const [showFirmModal, setShowFirmModal] = useState<boolean>(false)
  const [showCreateGroupModal, setShowCreateGroupModal] =
    useState<boolean>(false)

  const [firmForm] = Form.useForm<FirmManagementFormFieldTypes>()
  const [groupForm] = Form.useForm<GroupManagementFormFieldTypes>()
  const [actionFirmId, setActionFirmId] = useState<string | null>(null)
  const [actionGroupId, setActionGroupId] = useState<string | null>(null)
  const headerRef = useRef<HTMLDivElement>(null)
  const tableHeight = useTableHeight(headerRef)

  const { data, isFetching, isLoading } = useListFirmsQuery({
    page: 1,
    status: FirmStatus.All,
    pageSize: 10,
  })

  const handleCreateGroupClicked = (firmId: string) => {
    setShowCreateGroupModal(true)
    groupForm.setFieldValue('firmId', firmId)
  }

  const handleEditFirm = (id: string) => {
    setActionFirmId(id)
    setShowFirmModal(true)
  }

  const handleEditGroup = (id: string, firmId: string) => {
    setActionGroupId(id)
    setActionFirmId(firmId)
    setShowCreateGroupModal(true)
  }

  return (
    <>
      <div ref={headerRef}>
        <FirmManagementUserControls
          onCreateFirm={() => setShowFirmModal(true)}
        />
      </div>
      <FirmManagementTable
        firmList={data?.data ?? []}
        isLoading={isLoading}
        isFetching={isFetching}
        onEditFirm={handleEditFirm}
        createGroupClicked={handleCreateGroupClicked}
        height={tableHeight}
        onEditGroup={handleEditGroup}
      />
      {showFirmModal && (
        <ActionFirmModal
          showActionModal={showFirmModal}
          handleCloseModal={() => setShowFirmModal(false)}
          editFirmId={actionFirmId}
          setEditFirmId={setActionFirmId}
          form={firmForm}
        />
      )}
      {showCreateGroupModal && (
        <ActionGroupModal
          showActionModal={showCreateGroupModal}
          handleCloseModal={() => {
            setShowCreateGroupModal(false)
            setActionGroupId(null)
            setActionFirmId(null)
          }}
          editGroupId={actionGroupId}
          firmId={actionFirmId}
          form={groupForm}
        />
      )}
    </>
  )
}
